export default IconMoodLookDown => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-mood-look-down" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
  <path d="M9 13h.01" />
  <path d="M15 13h.01" />
  <path d="M11 17h2" />
</svg>`;